"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTemplate = exports.isTemplateOriginal = exports.isTemplate2024 = void 0;
const typeguard_1 = require("./../types/typeguard");
const typeguard_2 = require("../types/typeguard");
const CoverSurface_1 = require("./CoverSurface");
const TemplateSurface_1 = require("./TemplateSurface");
const Design_1 = require("./Design");
const Layer_1 = require("./layers/Layer");
const TemplateSize_1 = require("./TemplateSize");
const WoodenBox_1 = require("./WoodenBox");
const typeguards_1 = require("au-types/lib/typeguards");
//future state based on https://artifactteam.atlassian.net/wiki/x/KAA6qg
//used in cards, maybe will be used books/prints/frames as makes sense
const template2024RuleSet = {
  designs: value => Array.isArray(value) && value.every(Design_1.isDesign),
  layers: value => Array.isArray(value) && value.every(Layer_1.isLayer),
  sizes: value => Array.isArray(value) && value.every(TemplateSize_1.isTemplateSize),
  surfaces: value => Array.isArray(value) && value.every(TemplateSurface_1.isTemplate2024Surface),
  pages: value => (0, typeguard_1.isObject)(value) && (0, typeguard_1.isNumber)(value.max) && (0, typeguard_1.isNumber)(value.min),
  templateSchemaVersion: value => value === '2024-11-13'
};
const isTemplate2024 = t => {
  var _a;
  return ((_a = t === null || t === void 0 ? void 0 : t.artLevelProperties) === null || _a === void 0 ? void 0 : _a.templateSchemaVersion) === '2024-11-13';
};
exports.isTemplate2024 = isTemplate2024;
const isTemplateOriginal = t => {
  var _a;
  return ((_a = t === null || t === void 0 ? void 0 : t.artLevelProperties) === null || _a === void 0 ? void 0 : _a.templateSchemaVersion) === undefined;
};
exports.isTemplateOriginal = isTemplateOriginal;
const templateRuleSet = {
  cssClass: typeguard_1.isNonEmptyString,
  price: value => value ? (0, typeguard_1.isNonEmptyString)(value) : true,
  additionalSizes: value => value ? Array.isArray(value) && value.reduce((acc, curr) => acc && (0, TemplateSize_1.isTemplateSize)(curr), true) : true,
  coverSurfaces: value => value ? Array.isArray(value) && value.every(CoverSurface_1.isCoverSurface) : true,
  designs: value => Array.isArray(value) && value.reduce((acc, curr) => acc && (0, Design_1.isDesign)(curr), true),
  envelope: value => value ? (0, typeguard_1.isObject)(value) : true,
  layers: value => Array.isArray(value) &&
  // Checking for badge type layers here is desired so that we don't have to update all the hammer files to remove badges all at once
  // The badge layer and base layer do not fully overlap and will thus fail the type guard if this check isn't included here
  value.reduce((acc, curr) => acc && (curr && curr.type === 'badge' || (0, Layer_1.isLayer)(curr)), true),
  pages: value => (0, typeguard_1.isObject)(value) && (0, typeguard_1.isNumber)(value.max) && (0, typeguard_1.isNumber)(value.min),
  size: value => (0, typeguard_1.isObject)(value) && (0, typeguard_1.isNumber)(value.width) && (0, typeguard_1.isNumber)(value.height),
  designGroups: value => value ? Array.isArray(value) && value.reduce((acc, curr) => acc && (0, Design_1.isDesignGroup)(curr), true) : true,
  surface: TemplateSurface_1.isTemplateSurface,
  hasPreview: value => value ? (0, typeguard_1.isBool)(value) : true,
  woodenBox: (0, typeguards_1.optional)(WoodenBox_1.isWoodenBox),
  immutablePages: value => value ? Array.isArray(value) && value.every(typeguard_1.isNumber) : true,
  templateSchemaVersion: value => value === undefined
};
const isTemplate = t => (0, typeguard_2.isType)(t, templateRuleSet) || (0, typeguard_2.isType)(t, template2024RuleSet);
exports.isTemplate = isTemplate;